/* eslint-disable @typescript-eslint/no-use-before-define */
import { usePage } from "@inertiajs/react";
import TabsNavContainer from "components/shared/TabsNavContainer";
import Container from "hardcover-ui/components/Container";
import TabLink from "hardcover-ui/components/TabLink";
import { BookPageProps } from "pages/clientverse/books/show.props";

export default function BookTabs() {
  const { book } = usePage<BookPageProps>().props;

  return (
    <Container size="md" className="mt-4">
      <TabsNavContainer>
        <TabLink href={`/books/${book.slug}`} size="lg">
          <>Book Info</>
        </TabLink>

        {book.reviewsCount > 0 && (
          <TabLink
            href={`/books/${book.slug}/reviews`}
            size="lg"
            badgeClass="hidden lg:inline ml-2"
            badge={book.reviewsCount > 0 ? book.reviewsCount : null}
            greedy
          >
            <>Reviews</>
          </TabLink>
        )}

        {book.editionsCount > 0 && (
          <TabLink
            href={`/books/${book.slug}/editions`}
            size="lg"
            badgeClass="hidden lg:inline ml-2"
            badge={book.editionsCount > 0 ? book.editionsCount : null}
            greedy
          >
            <>Editions</>
          </TabLink>
        )}

        {book.listsCount > 0 && (
          <TabLink
            href={`/books/${book.slug}/lists`}
            size="lg"
            badgeClass="hidden lg:inline ml-2"
            badge={book.listsCount > 0 ? book.listsCount : null}
          >
            <>Lists</>
          </TabLink>
        )}

        {book.charactersCount > 0 && (
          <TabLink
            href={`/books/${book.slug}/characters`}
            size="lg"
            badgeClass="hidden lg:inline ml-2"
            badge={book.charactersCount > 0 ? book.charactersCount : null}
            greedy
          >
            <>Characters</>
          </TabLink>
        )}

        {book.promptsCount > 0 && (
          <TabLink
            href={`/books/${book.slug}/prompts`}
            size="lg"
            badgeClass="hidden lg:inline ml-2"
            badge={book.promptsCount > 0 ? book.promptsCount : null}
            greedy
          >
            <>Prompts</>
          </TabLink>
        )}

        {book.activitiesCount > 0 && (
          <TabLink
            href={`/books/${book.slug}/activity`}
            size="lg"
            badgeClass="hidden lg:inline ml-2"
            badge={book.activitiesCount > 0 ? book.activitiesCount : null}
          >
            <>Feed</>
          </TabLink>
        )}
      </TabsNavContainer>
    </Container>
  );
}
